import { shadows, theme } from '@/utils/theme';
import { ACCENT_COLORS, TEXT_COLORS } from '@/constants/colors';
import { FIELD_BORDER } from './constants';

export const classes = {
  icon: 'text-taupe-1',
};

export const styles = {
  textInput: (isOpen?: boolean) => ({
    // Outranks the theme's form-control rule that sets a 6px radius on inputs
    '&.MuiInputBase-root.MuiInput-root': {
      borderRadius: theme.shape.rounded['2xl'],
    },
    // Kept at single-class specificity so a wrapper can restyle the field
    '&': {
      gap: '10px',
      padding: '9px 14px',
      backgroundColor: 'rgba(255, 255, 255, 0.82)',
      border: `1px solid ${isOpen ? ACCENT_COLORS.primary : FIELD_BORDER}`,
      boxShadow: shadows['aurora-card'],
      cursor: 'pointer',
      caretColor: 'transparent',
      color: TEXT_COLORS.primary,
      fontSize: '13px',
      fontWeight: 600,
      transition: 'border-color 0.2s',
    },
    '&:hover:not(.Mui-disabled, .Mui-error)': {
      borderColor: `color-mix(in srgb, ${ACCENT_COLORS.primary} 40%, ${FIELD_BORDER})`,
    },
    '& .MuiInputBase-input': {
      padding: 0,
      height: 'auto',
      cursor: 'pointer',
      color: 'inherit',
      font: 'inherit',
    },
    '& .MuiInputAdornment-root': {
      margin: 0,
      height: 'auto',
      color: 'inherit',
    },
    '& .Mui-disabled': {
      cursor: 'not-allowed',
    },
  }),
};
